import React, {
  useEffect,
  useState,
  Fragment,
  useRef,
  useCallback,
} from "react";
import $ from "jquery";
import jQuery from "jquery";
import DataTable from "datatables.net";
import Spinner from "react-bootstrap/Spinner";
import ReactDOM from "react-dom";
import Cookies from "universal-cookie";

import PropTypes from "prop-types";

import { SRLWrapper } from "simple-react-lightbox";

import {
  getApiUrl,
  getPantDocFromNivel,
  getDecodedCookie,
  getAhorayyyymmdd,
  btnsImportExportFile,
  importFileToBBDD,
} from "../../helpers/helperApp";

// JS
import "datatables.net";
import "datatables.net-dt";
import "datatables.net-bs4";
import "datatables.net-buttons";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import "datatables.net-select";
import "datatables.net-rowreorder";
import "datatables.net-rowgroup";
import "datatables.net-responsive";

let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy =
  (h < 10 ? (h = "0" + h) : (h = h)) +
  "/" +
  (mesHoy < 10 ? (mesHoy = "0" + mesHoy) : (mesHoy = mesHoy)) +
  "/" +
  date.getFullYear();

function MiDataTable(props) {
  const { id, data, columnas: columnasProp, formulario, selectId, selectIds, selectIdsKeySearch, lastSelectedId, goToEquiposL, columnGoToEquiposL } = props;

  const lastSelectedIdRef = useRef(lastSelectedId || null);
  const [highlightTrigger, setHighlightTrigger] = useState(0);
  const [tableReady, setTableReady] = useState(false);
  const searchTimeoutRef = useRef(null);
  const lastSentSearchValueRef = useRef("");
  const isInitialLoadRef = useRef(true);

  useEffect(() => {
    if (lastSelectedId) {
      lastSelectedIdRef.current = lastSelectedId;
      setTimeout(() => {
        highlightRowById(lastSelectedId);
      }, 300);
    }
  }, [lastSelectedId]);

  useEffect(() => {
    if (data && data.length > 0 && lastSelectedIdRef.current) {
      setTimeout(() => {
        highlightRowById(lastSelectedIdRef.current);
      }, 300);
    }
  }, [data]);

  let {
    buttons,
    ordering,
    order,
    searching,
    paging,
    select,
    handleEditReg,
    handleDeleteItem,
    saveLoadingTable,
    loadingTable,
    estadoForm,
    columnactions,
    traduction,
    linkColumns,
    functionClickTd,
    pagelength,
    columnsFunctionClickTd,
    txtFilterTable,
    noDisplay,
    rowreorder,
    functionAfterReorder,
    functionAfterSelect,
    clickBtnDataTableButtons,
    importExportFile,
    fnReloadTable,
    idRegImportExport,
    paginationInfo,
    onSearchChange,
    onPageLengthChange,
    onSortChange,
    searchBackend,
    exportExcelUrl,
    exportPdfUrl,
    showNativeInfo,
    showNativePaging,
    showNativeSearch,
    showNativeLengthMenu,
  } = props;

  const onSearchChangeRef = useRef(onSearchChange);
  const onPageLengthChangeRef = useRef(onPageLengthChange);

  useEffect(() => {
    onSearchChangeRef.current = onSearchChange;
  }, [onSearchChange]);
  useEffect(() => {
    onPageLengthChangeRef.current = onPageLengthChange;
  }, [onPageLengthChange]);

  const handleExportExcel = () => {
    if (!exportExcelUrl) return;
    let url = exportExcelUrl;
    if (
      searchBackend &&
      $.fn.DataTable &&
      $.fn.DataTable.isDataTable("." + id)
    ) {
      const oTable = $("." + id).DataTable();
      if (oTable) {
        const searchTerm = oTable.search();
        if (searchTerm) {
          url +=
            (url.includes("?") ? "&" : "?") +
            "search=" +
            encodeURIComponent(searchTerm);
        }
      }
    }
    window.location.href = url;
  };

  const handleExportPdf = () => {
    if (!exportPdfUrl) return;
    let url = exportPdfUrl;
    if (
      searchBackend &&
      $.fn.DataTable &&
      $.fn.DataTable.isDataTable("." + id)
    ) {
      const oTable = $("." + id).DataTable();
      if (oTable) {
        const searchTerm = oTable.search();
        if (searchTerm) {
          url +=
            (url.includes("?") ? "&" : "?") +
            "search=" +
            encodeURIComponent(searchTerm);
        }
      }
    }
    window.open(url, "_blank");
  };

  var botones = [
    {
      extend: "pageLength",
      text: `<i style='font-size: 20px;' class='fal fa-list-ol'></i>`,
      className: "btn btn-flat mr-1 btn-outline-secondary button-page-length",
    },
    exportExcelUrl
      ? {
          text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
          className: "btn btn-flat mr-1 btn-outline-secondary",
          action: handleExportExcel,
        }
      : {
          extend: "excel",
          filename: hoy,
          text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
          className: "btn btn-flat mr-1 btn-outline-secondary",
          title: hoy,
          exportOptions: { columns: ":visible" },
        },
    exportPdfUrl
      ? {
          text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
          className: "btn btn-flat mr-1 btn-outline-secondary",
          action: handleExportPdf,
        }
      : {
          extend: "pdf",
          filename: hoy,
          text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
          className: "btn btn-flat mr-1 btn-outline-secondary",
          orientation: "landscape",
          title: hoy,
          exportOptions: { columns: ":visible" },
        },
    {
      extend: "colvis",
      text: `<i style='font-size: 20px;' class='fad fa-line-columns'></i>`,
      className: "btn btn-flat mr-1 btn-outline-secondary",
    },
  ];

  const cookies = new Cookies();
  const [noDisplayState, saveNoDisplayState] = useState(noDisplay);
  const fileInputRef = useRef(null);

  const existenBotones = (botones) => {
    let data = false;
    botones.map((boton) => {
      if (boton[0] != undefined) {
        if (boton[0].className.includes("btnSeleccion")) {
          data = true;
        }
      }
    });
    return data;
  };

  if (select !== undefined && select !== false) {
    if (select.style == "multi") {
      if (!existenBotones(botones)) {
        const newBtns = [
          {
            extend: "collection",
            text: "<i style='font-size: 20px' class='fal fa-check'></i>",
            className: "btn btn-flat mr-1 btn-outline-secondary btnSeleccion",
            buttons: [
              {
                text: "<i style='font-size: 20px' class='fal fa-check-square'></i>",
                className: "dt-button buttons-columnVisibility",
                action: function (e, dt, node, config) {
                  actionsBtnSelector(0);
                },
              },
              {
                text: "<i style='font-size: 20px' class='fal fa-square'></i>",
                className: "dt-button buttons-columnVisibility",
                action: function (e, dt, node, config) {
                  actionsBtnSelector(1);
                },
              },
              {
                text: "<i style='font-size: 20px' class='fas fa-check-square'></i>",
                className: "dt-button buttons-columnVisibility",
                action: function (e, dt, node, config) {
                  actionsBtnSelector(2);
                },
              },
            ],
          },
        ];
        botones.push(newBtns);
      }
    }
  }

  if (id == "manlogv2pend") {
    const newBtn = {
      extend: "collection",
      text: "<i style='font-size: 20px' class='fal fa-history'></i>",
      className: `btn btn-flat mr-1 btn-outline-secondary filterBtnManlogV2`,
      action: function (e, dt, node, config) {
        clickBtnDataTableButtons(true);
      },
    };
    botones.push(newBtn);
  }

  // ─── Configuración DataTables compartida ────────────────────────────────────
  // Siempre serverSide: false — la paginación backend la gestiona el hook,
  // DataTables solo renderiza los datos que recibe en cada página.
  const getDataTableConfig = (dataSource, cols) => ({
    mark: true,
    rowId: (a) => "#row-" + a.id,
    dom: buttons,
    data: dataSource,
    columns: cols,
    ordering: ordering,
    order: order,
    searching: searching,
    serverSide: false, // ← SIEMPRE false: el hook gestiona la paginación
    search: undefined, // ← sin filtro inicial de DataTables
    paging: paging,
    select: select,
    buttons: [botones],
    responsive: false,
    autoWidth: false,
    retrieve: true,
    pageLength: parseInt(pagelength),
    lengthMenu: [
      [5, 10, 25, 50, 100],
      ["5", "10", "25", "50", "100"],
    ],
    rowReorder: rowreorder ? true : false,
    deferRender: true,
    language: {
      sProcessing: traduction.sprocessing.title,
      sLengthMenu: traduction.slengthmenu.title,
      sZeroRecords: traduction.szerorecords.title,
      sEmptyTable: traduction.semptytable.title,
      sInfo: paginationInfo || traduction.sinfo.title,
      sInfoEmpty: traduction.sinfoempty.title,
      sInfoFiltered: traduction.sinfofiltered.title,
      sInfoPostFix: traduction.sinfopostfix.title,
      sSearch: traduction.ssearch.title,
      sUrl: traduction.surl.title,
      sInfoThousands: traduction.sinfothousands.title,
      sLoadingRecords: traduction.sloadingrecords.title,
      oPaginate: {
        sFirst: traduction.sfirst.title,
        sLast: traduction.slast.title,
        sNext: traduction.snext.title,
        sPrevious: traduction.sprevious.title,
      },
      oAria: {
        sSortAscending: traduction.ssortascending.title,
        sSortDescending: traduction.ssortdescending.title,
      },
      select: { rows: traduction.rows.title },
      buttons: {
        copyTitle: traduction.copytitle.title,
        copyKeys: traduction.copykeys.title,
        copySuccess: {
          _: traduction.copysuccess.many.title,
          1: traduction.copysuccess.one.title,
        },
      },
    },
    rowCallback: function (row, data, index) {
      for (let item of row.children) {
        if (item.outerText.includes("#")) {
          item.bgColor = item.outerText;
          item.innerText = "";
        }
      }
    },
    initComplete: function (settings, json) {},
  });
  // ────────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    if (!$ || !$.fn || !$.fn.DataTable) {
      return;
    }

    // ─── CORRECCIÓN 1: Trabajar siempre con una copia local para no mutar la prop ───
    const columnas = columnasProp.map(col => ({ ...col }));
    // ────────────────────────────────────────────────────────────────────────────────

    const accionesMiDataTableIndex = columnas.findIndex(
      column => column["title"] === columnactions,
    );

    if (accionesMiDataTableIndex !== -1) {
      columnas.splice(accionesMiDataTableIndex, 1);
    }

    if (linkColumns != undefined) {
      for (let i = 0; i < columnas.length; i++) {
        columnas[i].createdCell = (td, cellData, rowData, row, col) => {
          if (linkColumns[i] != undefined) {
            if ("style" in rowData) {
              $(td).addClass(rowData["style"]);
            }
            if (typeof cellData == "string") {
              if (
                cellData.toLowerCase() != "Media".toLowerCase() &&
                cellData != "Average".toLowerCase() &&
                cellData.toLowerCase() != "Total".toLowerCase()
              ) {
                if (linkColumns[i].link == "/documentos") {
                  linkColumns[i].link = getPantDocFromNivel(
                    getDecodedCookie("nivel"),
                  );
                }
                if (
                  linkColumns[i].data.includes("/") &&
                  linkColumns[i].link != ""
                ) {
                  const links = linkColumns[i].data.split("/");
                  $(td).html(
                    "<a href='" +
                      window.location.origin +
                      linkColumns[i].link +
                      "/" +
                      rowData[links[0]] +
                      "/" +
                      rowData[links[1]] +
                      "' >" +
                      cellData +
                      "</a>",
                  );
                } else if (linkColumns[i].link != "") {
                  $(td).html(
                    "<a href='" +
                      window.location.origin +
                      linkColumns[i].link +
                      "/" +
                      rowData[linkColumns[i].data] +
                      "' >" +
                      cellData +
                      "</a>",
                  );
                }
              }
            }
          }
          if ("foto" in rowData || "img" in rowData) {
            if (cellData) {
              if (cellData.includes("/assets/")) {
                $(td).html(
                  "<img src='" +
                    getApiUrl(window.location.origin) +
                    cellData +
                    "' style='width: 50px !important; cursor: pointer;' />",
                );
              }
            } else {
              $(td).html("<span></span>");
            }
          }
          if (functionClickTd) {
            if (columnsFunctionClickTd) {
              if (columnsFunctionClickTd.includes(col)) {
                $(td).on("click", function (e) {
                  e.preventDefault();
                  functionClickTd(e, rowData);
                });
              }
            } else {
              $(td).on("click", function (e) {
                e.preventDefault();
                functionClickTd(e, rowData);
              });
            }
          }
          if (columnGoToEquiposL !== undefined && col == columnGoToEquiposL) {
            if (parseInt(rowData.idequ) > 0) {
              $(td).html(
                "<div style='display:flex; justify-content:center; align-items:center;'><div class='go-to-equipos' data-row='" +
                  JSON.stringify(rowData).replace(/'/g, "&#39;") +
                  "'><i class='far fa-external-link mr-1'></i></div></div>",
              );
              $(td)
                .find(".go-to-equipos")
                .on("click", function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  let row = JSON.parse($(this).attr("data-row"));
                  goToEquiposL(e, row);
                });
            }
          }
          if (id == "kpis") {
            if (typeof cellData == "string" && rowData.idcentro != -1) {
              if (
                cellData.toLowerCase().includes("Media".toLowerCase()) ||
                cellData.toLowerCase().includes("Average".toLowerCase()) ||
                cellData.toLowerCase().includes("Total".toLowerCase())
              ) {
                $(td).addClass("tdAvg");
                $(td).parent("tr").addClass("trAvg");
              }
            }
            if (typeof cellData == "string" && rowData.idcentro == -1) {
              $(td).addClass("tdTotal");
              $(td).parent("tr").addClass("trTotal");
            }
            if (col > 0) {
              $(td).addClass("text-right");
            }
            if (col == 4) {
              $(td)[0].innerText = $(td)[0].innerText + " %";
              if (cellData < 5) {
                $(td).addClass("alert-success");
              }
              if (cellData >= 5 && cellData <= 10) {
                $(td).addClass("alert-warning");
              }
              if (cellData > 10) {
                $(td).addClass("alert-danger");
              }
            }
            if (col == 6 || col == 7) {
              if (cellData > 0) {
                $(td).addClass("alert-success");
              }
              if (cellData == 0) {
                $(td).addClass("alert-warning");
              }
              if (cellData < 0) {
                $(td).addClass("alert-danger");
              }
              $(td)[0].innerText = $(td)[0].innerText + " €";
            }
          }
          if (id == "stockart") {
            if (typeof cellData == "string" && rowData.id_ubicacion == -1) {
              $(td).addClass("tdTotal");
              $(td).parent("tr").addClass("trTotal");
            }
            if (col > 1) {
              $(td).addClass("text-right");
              if (rowData.stock_min > 0) {
                if (parseInt(rowData.unidades) <= 0) {
                  $(td).addClass("alert-danger");
                }
                if (parseInt(rowData.unidades) > parseInt(rowData.stock_min)) {
                  $(td).addClass("alert-success");
                }
                if (parseInt(rowData.unidades) <= parseInt(rowData.stock_min)) {
                  $(td).addClass("alert-warning");
                }
              } else {
                if (parseInt(rowData.unidades) <= 0) {
                  $(td).addClass("alert-danger");
                }
                if (parseInt(rowData.unidades) > 0) {
                  $(td).addClass("alert-success");
                }
              }
            }
          }
        };
      }
    } else {
      for (let i = 0; i < columnas.length; i++) {
        columnas[i].createdCell = (td, cellData, rowData, row, col) => {
          if ("style" in rowData) {
            $(td).addClass(rowData["style"]);
          }
          if ("foto" in rowData || "img" in rowData) {
            if (cellData) {
              if (cellData.includes("/assets/")) {
                let templateFoto = `<div><div class="containerImgTablePending"><img class="imgUplmTablePending" src=${getApiUrl(window.location.origin) + cellData} /></div></div>`;
                $(td).html(templateFoto);
              }
            } else {
              $(td).html("<span></span>");
            }
          }
          if (functionClickTd) {
            if (columnsFunctionClickTd) {
              if (columnsFunctionClickTd.includes(col)) {
                $(td).on("click", function (e) {
                  e.preventDefault();
                  functionClickTd(e, rowData);
                });
              }
            } else {
              $(td).on("click", function (e) {
                e.preventDefault();
                functionClickTd(e, rowData);
              });
            }
          }
          if (columnGoToEquiposL !== undefined && col == columnGoToEquiposL) {
            if (parseInt(rowData.idequ) > 0) {
              $(td).html(
                "<div style='display:flex; justify-content:center; align-items:center;'><div class='go-to-equipos' data-row='" +
                  JSON.stringify(rowData).replace(/'/g, "&#39;") +
                  "'><i class='far fa-external-link mr-1'></i></div></div>",
              );
              $(td)
                .find(".go-to-equipos")
                .on("click", function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  let row = JSON.parse($(this).attr("data-row"));
                  goToEquiposL(e, row);
                });
            }
          }
          if (id == "kpis") {
            if (typeof cellData == "string" && rowData.idcentro != -1) {
              if (
                cellData.toLowerCase().includes("Media".toLowerCase()) ||
                cellData.toLowerCase().includes("Average".toLowerCase()) ||
                cellData.toLowerCase().includes("Total".toLowerCase())
              ) {
                $(td).addClass("tdAvg");
                $(td).parent("tr").addClass("trAvg");
              }
            }
            if (typeof cellData == "string" && rowData.idcentro == -1) {
              $(td).addClass("tdTotal");
              $(td).parent("tr").addClass("trTotal");
            }
            if (col > 0) {
              $(td).addClass("text-right");
            }
            if (col == 4) {
              $(td)[0].innerText = $(td)[0].innerText + " %";
              if (cellData < 5) {
                $(td).addClass("alert-success");
              }
              if (cellData >= 5 && cellData <= 10) {
                $(td).addClass("alert-warning");
              }
              if (cellData > 10) {
                $(td).addClass("alert-danger");
              }
            }
            if (col == 6 || col == 7) {
              if (cellData > 0) {
                $(td).addClass("alert-success");
              }
              if (cellData == 0) {
                $(td).addClass("alert-warning");
              }
              if (cellData < 0) {
                $(td).addClass("alert-danger");
              }
              $(td)[0].innerText = $(td)[0].innerText + " €";
            }
          }
          if (id == "stockart") {
            if (typeof cellData == "string" && rowData.id_ubicacion == -1) {
              $(td).addClass("tdTotal");
              $(td).parent("tr").addClass("trTotal");
            }
            if (col > 0) {
              $(td).addClass("text-right");
            }
          }
        };
      }
    }

    // NOTA: el push de la columna de acciones se hace DESPUÉS del columnas.map()
    // de semáforos para evitar que el map sobreescriba el createdCell de acciones.

    showNativeInfo = showNativeInfo !== undefined ? showNativeInfo : true;
    showNativePaging = showNativePaging !== undefined ? showNativePaging : true;
    showNativeSearch = showNativeSearch !== undefined ? showNativeSearch : true;
    showNativeLengthMenu =
      showNativeLengthMenu !== undefined ? showNativeLengthMenu : true;

    let domString = "r";
    if (showNativeLengthMenu) domString += "l";
    if (showNativeSearch && searching) domString += "f";
    if (showNativeInfo) domString += "i";
    if (showNativePaging && paging) domString += "p";
    domString += "t";

    buttons === undefined || buttons === true || buttons === "true"
      ? (buttons = "B" + domString)
      : (buttons = domString);
    ordering === undefined ? (ordering = true) : (ordering = ordering);
    order === undefined ? (order = [[0, "asc"]]) : (order = order);
    searching === undefined ? (searching = true) : (searching = searching);
    paging === undefined ? (paging = true) : (paging = paging);
    pagelength === undefined
      ? (pagelength = traduction.defaultpagelength)
      : (pagelength = pagelength);
    select === undefined ? (select = false) : (select = select);

    const columnasHaveData =
      Array.isArray(columnas) &&
      columnas.length > 0 &&
      columnas.every(
        (col) =>
          col &&
          typeof col === "object" &&
          "data" in col &&
          col.data !== undefined &&
          col.data !== null &&
          col.data !== "",
      );

    // Agregar columna "Equipo" automáticamente si no existe (igual que MiDataTable.js)
    if (
      (id == "manlogv2his" || id == "manloghis") &&
      columnasHaveData &&
      !columnas.some((col) => col && col.data == "idequ")
    ) {
      columnas.push({
        title: "Equipo",
        data: "idequ",
        className: "text-center",
        sortable: false,
      });
    }

    columnas.map((columna, i) => {
      if (i == 4 && (id == "manlogv2his" || id == "manloghis")) {
        const titleME =
          "<div class='text-center w-100 pl-3'>" + columnas[4].title + "</div>";
        columnas[4].title = titleME;
        columnas[4].sTitle = titleME;
        columnas[4].sortable = false;
        columnas[4].width = "10%";
        columnas[4].className = "text-center";
        columnas[4].sClass = "text-center";
        columna.createdCell = (td, cellData, rowData, row, col) => {
          $(td).addClass(rowData.style);
          $(td).empty();
          ReactDOM.render(
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "6px",
                cursor: "default",
              }}>
              {/* Semáforo adjuntos mantenimiento */}
              <div
                title="Adjuntos mantenimiento"
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  backgroundColor:
                    parseInt(rowData.numadj) > 0 ? "#28a745" : "#dc3545",
                  flexShrink: 0,
                  cursor: "default",
                }}
              />
            </div>,
            td,
          );
        };
      }
      if (i == 5 && (id == "manlogv2his" || id == "manloghis")) {
        const titleME =
          "<div class='text-center w-100 pl-3'>" + columnas[5].title + "</div>";
        columnas[5].title = titleME;
        columnas[5].sTitle = titleME;
        columnas[5].sortable = false;
        columnas[5].width = "10%";
        columnas[5].className = "text-center";
        columnas[5].sClass = "text-center";
        columna.createdCell = (td, cellData, rowData, row, col) => {
          $(td).addClass(rowData.style);
          $(td).empty();
          ReactDOM.render(
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "6px",
                cursor: "default",
              }}>
              {/* Semáforo adjuntos equipo */}
              <div
                title="Adjuntos equipo"
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  backgroundColor:
                    parseInt(rowData.numadjequi) > 0 ? "#28a745" : "#dc3545",
                  flexShrink: 0,
                  cursor: "default",
                }}
              />
            </div>,
            td,
          );
        };
      }
      if (i == 6 && (id == "manlogv2his" || id == "manloghis")) {
        columna.createdCell = (td, cellData, rowData, row, col) => {
          $(td).addClass(rowData.style);
          $(td).empty();
          if (parseInt(rowData.idequ) > 0) {
            ReactDOM.render(
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    goToEquiposL(e, rowData);
                  }}>
                  <i className="far fa-external-link mr-1"></i>
                </div>
              </div>,
              td,
            );
          } else {
            ReactDOM.render(
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={(e) => functionClickTd(e, rowData)}></div>,
              td,
            );
          }
        };
      }
      if (i == 7 && id == "lineaslogboook") {
        columna.createdCell = (td, cellData, rowData, row, col) => {
          $(td).addClass(rowData.style);
          $(td).empty();
          if (parseInt(rowData.numfir) > 0) {
            ReactDOM.render(
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={(e) => functionClickTd(e, rowData)}>
                <i className="fal fa-file-signature mr-1"></i>
              </div>,
              td,
            );
          } else {
            ReactDOM.render(
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={(e) => functionClickTd(e, rowData)}></div>,
              td,
            );
          }
        };
      }
      if (id == "manlogv2pend") {
        const ahora = getAhorayyyymmdd();
        columna.createdCell = (td, cellData, rowData, row, col) => {
          $(td).empty();
          ReactDOM.render(
            <div onClick={(e) => functionClickTd(e, rowData)}>
              <span dangerouslySetInnerHTML={{ __html: cellData }}></span>
            </div>,
            td,
          );
          if (
            rowData.exp_date <= ahora &&
            (rowData.noleido === false || rowData.noleido === "false")
          ) {
            $(td).addClass("text-bold text-danger");
          } else if (rowData.noleido === false || rowData.noleido === "false") {
            $(td).addClass("text-bold");
          }
        };
      }
    });

    // Push de acciones DESPUÉS del map para que ningún bloque del map sobreescriba su createdCell
    if (columnactions != null && columnactions != "null" && columnactions != "") {
      columnas.push({
        title: columnactions,
        data: null,
        className: 'text-center',
        sortable: false,
        createdCell: (td, cellData, rowData, row, col) => {
          $(td).empty();
          ReactDOM.render(
            <div className="flex-center">
              <span
                id={rowData.id}
                className=" btn btn-flat btn-outline-primary mr-1"
                style={{ border: 0 }}
                onClick={e => { lastSelectedIdRef.current = rowData.id; setHighlightTrigger(prev => prev + 1); handleEditReg(e) }} >
                <i className="fal fa-edit" id={rowData.id} onClick={e => { lastSelectedIdRef.current = rowData.id; setHighlightTrigger(prev => prev + 1); handleEditReg(e) }}></i>
              </span>
              {
                estadoForm !== "disabled" && estadoForm !== "readonly"
                  ?
                  <span
                    id={rowData.id}
                    data-idpadre={rowData.iddoc ? rowData.iddoc : null}
                    className="btn btn-flat btn-outline-danger deleteRow"
                    style={{ border: 0 }}
                    onClick={e => { handleDeleteItem(e) }}>
                    <i id={rowData.id} data-idpadre={rowData.iddoc ? rowData.iddoc : null} className="fal fa-trash-alt deleteRow" onClick={e => { handleDeleteItem(e) }}></i>
                  </span>
                  :
                  null
              }
            </div>
            , td);
        }
      });
    }

    if (importExportFile == true) {
      botones = [...botones];
      botones = btnsImportExportFile(
        saveLoadingTable,
        traduction,
        fileInputRef,
        botones,
        id,
        data,
        idRegImportExport,
      );
    }

    // ─── Inicialización / actualización de DataTables ────────────────────────
    // Si la tabla ya existe, actualizamos los datos sin destruirla para evitar
    // el error de React: "render(): The React-rendered content was removed"
    const tableExists = $.fn.DataTable && $.fn.DataTable.isDataTable("." + id);
    
    if (tableExists) {
      try {
        const oTable = $("." + id).DataTable();
        if (oTable) {
          oTable.clear();
          if (data && data.length > 0) {
            oTable.rows.add(data);
          }
          oTable.draw(false);
          if (saveLoadingTable) {
            saveLoadingTable(false);
          }
          return;
        }
      } catch (e) {
        console.error("Error updating DataTable:", e);
      }
    }
    
    // Solo llega aquí si la tabla no existe - primera vez o tras error
    $("." + id).DataTable(getDataTableConfig(data && data.length > 0 ? data : null, columnas));

    if (saveLoadingTable) {
      saveLoadingTable(false);
    }

    if (functionAfterReorder != null) {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
        let tabla;
        try {
          tabla = $("#" + id).DataTable();
        } catch (e) {}
        if (tabla && tabla.on) {
          tabla.on("row-reorder", function (e, diff, edit) {
            functionAfterReorder(e, diff, edit);
          });
        }
      }
    }

    if (functionAfterSelect != null) {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
        let tabla;
        try {
          tabla = $("#" + id).DataTable();
        } catch (e) {}
        if (tabla && tabla.off && tabla.on) {
          tabla.off("click", "tr");
          tabla.on("click", "tr", function (e, dt, type, indexes) {
            if (e.currentTarget && e.currentTarget.id != "") {
              setTimeout(() => {
                if ($.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
                  let idRow = tabla.row(this).id();
                  const datos = $("#" + id)
                    .DataTable()
                    .rows()
                    .data();
                  const selectedRows = $("#" + id)
                    .DataTable()
                    .rows({ selected: true })
                    .data();
                  functionAfterSelect(idRow, id, datos, selectedRows);
                }
              }, 500);
            }
          });
        }
      }
    }

    // ─── Suscribir eventos de búsqueda y paginación ─────────────────────────
    // Solo se suscribe una vez cuando la tabla está lista
    if (!tableReady && $.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
      setTableReady(true);
      const oTable = $("." + id).DataTable();
      if (!oTable) return;

      // Evento de búsqueda - solo se suscribe una vez cuando la tabla está lista
      const handleSearch = (e, settings) => {
        // Ignorar el primer evento que es automático al cargar datos desde el servidor
        if (isInitialLoadRef.current) {
          isInitialLoadRef.current = false;
          return;
        }
        
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
          const searchValue = settings.oPreviousSearch.sSearch;
          if (
            onSearchChangeRef.current &&
            searchValue !== undefined &&
            searchValue !== lastSentSearchValueRef.current
          ) {
            lastSentSearchValueRef.current = searchValue;
            onSearchChangeRef.current(searchValue);
          }
        }, 500);
      };
      oTable.on("search.dt", handleSearch);

      // Evento de cambio de longitud de página
      if (onPageLengthChangeRef.current) {
        const handleLength = (e, settings, len) => {
          onPageLengthChangeRef.current(len);
        };
        oTable.on("length.dt", handleLength);
      }

      // Evento de ordenación
      if (props.onSortChange) {
        const handleOrder = (e, settings) => {
          const order = settings.aaSorting[0];
          if (!order) return;
          const colIndex = order[0];
          const direction = order[1];
          const columns = settings.aoColumns;
          const columnData = columns[colIndex]?.data || columns[colIndex]?.mData;
          if (columnData) {
            props.onSortChange(columnData, direction);
          }
        };
        oTable.on("order.dt", handleOrder);
      }
    }
  }, [data, formulario.id, selectIds]);

  function actionsBtnSelector(boton) {
    if (!$.fn.DataTable.isDataTable("." + id)) {
      return;
    }
    let oTable;
    try {
      oTable = $("." + id).DataTable();
    } catch (e) {
      return;
    }
    if (!oTable || !oTable.rows) {
      return;
    }
    switch (boton) {
      case 0:
        oTable.rows({ search: "applied" }).select();
        break;
      case 1:
        oTable.rows({ search: "applied" }).deselect();
        break;
      case 2:
        var rows = oTable.rows({ selected: true, search: "applied" })[0];
        oTable.rows({ search: "applied" }).select();
        oTable.rows(rows).deselect();
        break;
    }
  }

  function removeAccents(data) {
    if (data.normalize) {
      return data + " " + data.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    return data;
  }
  var searchType = jQuery.fn.DataTable.ext.type.search;
  searchType.string = function (data) {
    return !data ? "" : typeof data === "string" ? removeAccents(data) : data;
  };
  searchType.html = function (data) {
    return !data
      ? ""
      : typeof data === "string"
        ? removeAccents(data.replace(/<.*?>/g, ""))
        : data;
  };

  const highlightRowById = useCallback(
    (idToHighlight) => {
      if (!idToHighlight) {
        return;
      }
      try {
        if (!$.fn.DataTable || !$.fn.DataTable.isDataTable("." + id)) {
          return;
        }
        const oTable = $("." + id).DataTable();
        if (!oTable || !oTable.table || !oTable.table().node) {
          return;
        }
        const tableNode = oTable.table().node();
        const targetDomId = `#row-${idToHighlight}`;

        $(tableNode).find("tbody tr.selectedRow").removeClass("selectedRow");

        const $rowByDomId = $(tableNode)
          .find("tbody tr")
          .filter(function () {
            return this.id === targetDomId;
          });

        if ($rowByDomId.length) {
          $rowByDomId.addClass("selectedRow");
          return;
        }

        if (oTable.rows) {
          oTable.rows({ page: "current" }).every(function () {
            const rowData = this.data();
            if (
              rowData?.id !== undefined &&
              String(rowData.id) === String(idToHighlight)
            ) {
              $(this.node()).addClass("selectedRow");
            }
          });
        }
      } catch (e) {}
    },
    [id],
  );

  useEffect(() => {
    const idToHighlight =
      highlightTrigger > 0
        ? lastSelectedIdRef.current
        : formulario?.id || lastSelectedIdRef.current;
    if (!idToHighlight) {
      return;
    }
    const timeoutId = setTimeout(() => {
      highlightRowById(idToHighlight);
    }, 300);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [highlightTrigger, formulario?.id, id]);

  useEffect(() => {
    if (
      !selectIds ||
      !selectIds.length ||
      !$.fn.DataTable ||
      !$.fn.DataTable.isDataTable("." + id)
    ) {
      return;
    }
    try {
      let table = $("#" + id).DataTable();
      if (!table || !table.rows || !table.rows().data) {
        return;
      }
      let rows = table.rows().data();
      let indexes = table.rows().indexes();
      for (let i = 0; i < rows.length; i++) {
        if (selectIds.includes(rows[i][selectIdsKeySearch])) {
          table.row(indexes[i]).select();
        }
      }
    } catch (e) {}
  }, [selectIds, selectIdsKeySearch, id]);

  useEffect(() => {
    if (
      !selectId ||
      !selectId.id ||
      !$.fn.DataTable ||
      !$.fn.DataTable.isDataTable("." + id)
    ) {
      return;
    }
    const tableElement = document.querySelector("." + id);
    if (tableElement && !tableElement.dataset.eventsAttached2) {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
        try {
          const oTable = $("." + id).DataTable();
          if (oTable) {
            oTable.on("page.dt", function () {
              setTimeout(() => {
                if (lastSelectedIdRef.current) {
                  highlightRowById(lastSelectedIdRef.current);
                }
              }, 500);
            });
            oTable.on("length.dt", function () {
              setTimeout(() => {
                if (lastSelectedIdRef.current) {
                  highlightRowById(lastSelectedIdRef.current);
                }
              }, 200);
            });
            tableElement.dataset.eventsAttached2 = "true";
          }
        } catch (e) {}
      }
    }
  }, [selectId, id]);

  useEffect(() => {
    if (paginationInfo && $.fn.DataTable.isDataTable("." + id)) {
      let oTable = $("." + id).DataTable();
      if (oTable) {
        oTable.settings()[0].oLanguage.sInfo = paginationInfo;
        oTable.draw(false);
      }
    }
  }, [paginationInfo, id]);

  // Cleanup: destruir DataTables al desmontar el componente para evitar fugas de memoria
  useEffect(() => {
    return () => {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
        try {
          $("." + id).DataTable().destroy();
        } catch (e) {}
      }
    };
  }, [id]);

  if (txtFilterTable != null && txtFilterTable != "") {
    let tabla = $("#" + id).DataTable();
    tabla.search(txtFilterTable).draw();
  }

  return (
    <Fragment>
      {loadingTable ? (
        <div
          style={{
            height: 50,
            marginTop: 5,
            marginBottom: 10,
            textAlign: "center",
          }}>
          <Spinner animation="border" />
        </div>
      ) : null}
      <div
        className={noDisplayState ? "noDisplay" : ""}
        style={{ overflowX: "auto" }}>
        <table
          id={id}
          className={
            id +
            " table table-sm table-bordered table-striped table-hover dataTable "
          }
          style={{
            width: "100%",
            cursor: functionClickTd ? "pointer" : "default",
          }}></table>
        <input
          id="importFileToBBDD"
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".xls,.xlsx"
          onChange={(e) =>
            importFileToBBDD(
              saveLoadingTable,
              traduction,
              id,
              fnReloadTable,
              idRegImportExport,
            )
          }
        />
      </div>
    </Fragment>
  );
}

export default MiDataTable;
